import { Interpolation } from "@emotion/core";
import { transparentize } from "polished";
import { grid } from "../../../../design-tokens/grid";
import { Device, DarkTheme } from "../../../../design-tokens/media-queries";
import { Fonts } from "../../../../design-tokens/fonts";
import { Colors } from "../../../../design-tokens/colors";

const card: Interpolation = {
  marginBottom: 2,

  [Device.DesktopTablet]: {
    marginBottom: grid(3),
  },
};

const heading: Interpolation = {
  display: "flex",
  alignItems: "center",
  fontSize: 22,
  lineHeight: "28px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(2),

  [Device.DesktopTablet]: {
    fontSize: 24,
  },
};

const order: Interpolation = {
  flexShrink: 0,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: grid(3.5),
  height: grid(3.5),
  fontSize: 16,
  fontWeight: Fonts.Weight.Bold,
  color: Colors.White,
  backgroundColor: Colors.Blue,
  borderRadius: "50%",
  marginRight: grid(2),

  [Device.DesktopTablet]: {
    position: "absolute",
    left: grid(-2.5),
    top: grid(2),
    width: grid(5),
    height: grid(5),
    fontSize: 24,
    border: `5px solid ${Colors.LightGrey}`,

    [DarkTheme]: {
      border: `5px solid ${Colors.DarkModeBlack}`,
    },
  },
};

const content: Interpolation = {
  fontSize: "18px",
  marginBottom: grid(2.5),
};

const cta: Interpolation = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  WebkitAppearance: "none",
  width: grid(19),
  height: grid(4),
  fontWeight: Fonts.Weight.SemiBold,
  color: Colors.Blue,
  backgroundColor: Colors.White,
  borderRadius: grid(4),

  ":hover": {
    textDecoration: "none",
  },

  [DarkTheme]: {
    color: Colors.DarkModeTextBlue,
    backgroundColor: transparentize(0.3, Colors.DarkModeDeepBlack),
  },
};

const detailContainer: Interpolation = {
  paddingTop: grid(1),
  paddingBottom: grid(1),
  marginBottom: grid(2.5),
};

const listItem: Interpolation = {
  display: "flex",
  fontSize: "18px",

  ":not(:last-child)": {
    marginBottom: grid(1.5),
  },

  "::before": {
    content: `''`,
    flexShrink: 0,
    display: "flex",
    width: grid(1),
    height: grid(1),
    borderRadius: "50%",
    backgroundColor: Colors.Blue,
    marginRight: grid(1.5),
    marginTop: grid(1),

    [DarkTheme]: {
      backgroundColor: Colors.DarkModeTextBlue,
    },
  },
};

const styles = {
  card,
  heading,
  order,
  content,
  cta,
  detailContainer,
  listItem,
};

export default styles;
